import { toast } from 'react-hot-toast';
import { Article } from '../types/Article';

const handleShare = async (article: Article) => {
  if (!article) {
    toast.error('Artigo não encontrado');
    return;
  }
  
  const articleUrl = `${window.location.origin}/article/${article.id}`;
  const shareData = {
    title: article.title,
    text: `Confira este artigo: ${article.title}`,
    url: articleUrl
  };
  
  try {
    // Verifica se está no Android e usa Web Share API
    if (navigator.share && /android/i.test(navigator.userAgent)) {
      try {
        await navigator.share(shareData);
        toast.success('Artigo compartilhado com sucesso!');
        return;
      } catch (shareError: any) {
        // Ignora erro de cancelamento pelo usuário
        if (shareError.name === 'AbortError') {
          return;
        }
        console.error('Erro específico do Share API:', shareError);
        // Tenta próximo método sem mostrar erro
      }
    }

    // Tenta usar Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(articleUrl);
        toast.success('Link copiado para a área de transferência!');
        return;
      } catch (clipboardError) {
        console.error('Erro do Clipboard:', clipboardError);
        // Tenta próximo método sem mostrar erro
      }
    }

    // Fallback para método legacy
    const textArea = document.createElement('textarea');
    textArea.value = articleUrl;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      textArea.remove();
      
      if (successful) {
        toast.success('Link copiado para a área de transferência!');
      } else {
        throw new Error('Falha ao copiar com execCommand');
      }
    } catch (execError) {
      console.error('Erro ao copiar usando execCommand:', execError);
      toast.error('Não foi possível copiar o link. Por favor, copie manualmente.');
    }

  } catch (error) {
    console.error('Erro ao compartilhar:', error);
    // Só mostra erro se realmente nenhum método funcionou
    toast.error('Não foi possível compartilhar. Tente copiar o link manualmente.');
  }
};

export default handleShare; 